import React from 'react';
import CheckoutLabels from '@tcp/core/src/utils/labels/cnc/checkout.labels';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '@tcp/core/src/utils/labels/labelUtilty';
import {
  hasGiftServiceError,
  getSfsErroMessage,
  getSaveForLaterItemsOrderItemId,
  getSaveForLaterItemsProductIds,
} from '@tcp/core/src/components/features/CnC/Checkout/util/utility';
import WarningPrompt from '@tcp/core/src/components/features/CnC/Checkout/organisms/WarningPrompt';

const SfsWarningPrompt = ({
  sfsError,
  cartOrderItems,
  globalLabels,
  setSFSErrors,
  handleSfsClearGiftService,
  addSFSItemsToSFL,
  toggleModalVisibility,
}) => {
  const checkoutLabels = getLabelFromCopyOrFromTranslation('checkout', CheckoutLabels);
  const giftServiceError = sfsError && hasGiftServiceError(sfsError);
  if (giftServiceError) {
    const itemIds = getSaveForLaterItemsOrderItemId(sfsError) || [];
    const productIds = getSaveForLaterItemsProductIds(sfsError) || [];
    return (
      <WarningPrompt
        heading={renderLabel(
          checkoutLabels.shipping.lbl_sfs_cart_item_error,
          'lbl_sfs_cart_item_error'
        )}
        body={renderLabel(checkoutLabels.shipping[getSfsErroMessage(sfsError)])}
        type="giftservices"
        cartOrderItems={cartOrderItems}
        itemIds={itemIds}
        labels={globalLabels}
        saveForLaterAction={() => {
          toggleModalVisibility({ isModalOpen: false });
          addSFSItemsToSFL(productIds);
        }}
        secondaryCtaAction={() => {
          setSFSErrors(null);
          handleSfsClearGiftService();
        }}
      />
    );
  }
  return null;
};

export default SfsWarningPrompt;
